var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import BaseModel from './BaseModel';
var UpsellItemModel = /** @class */ (function (_super) {
    __extends(UpsellItemModel, _super);
    function UpsellItemModel(data) {
        var _this = _super.call(this, data) || this;
        delete _this.name;
        _this.id = _this.assetId = data.asset_id;
        _this.targetPriceDelta = +data.target_price_delta;
        _this.conversionPrice = +data.conversion_price;
        _this.priority = +data.priority;
        return _this;
    }
    return UpsellItemModel;
}(BaseModel));
export default UpsellItemModel;



//////////////////
// WEBPACK FOOTER
// ./src/models/UpsellItemModel.ts
// module id = null
// module chunks = 